import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  Vehicle,
  VehicleApiService,
  VehicleTypeApiService,
  VehicleTypeDetail,
} from '@fc-core';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as VehicleActions from '../actions/vehicles-detail.actions';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import * as fromVehicles from '../reducers';
import { VehicleService } from '@fc-vehicles/service/vehicle.service';
import { of } from 'rxjs';

import { VehicleStatisticsApiService } from '../../service/vehicle-statistics-api.service';

@Injectable()
export class VehiclesDetailEffects {
  getVehicleTypeDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType(VehicleActions.getVehicleTypeDetails),
      switchMap(({ vehicleType }) => {
        return this.vehicleService.getVehicleTypeDetail(vehicleType).pipe(
          map((detail: VehicleTypeDetail) => {
            return VehicleActions.getVehicleTypeDetailsSuccess({
              typeDetail: detail,
            });
          }),
        );
      }),
    ),
  );

  getVehicleStats$ = createEffect(() =>
    this.actions$.pipe(
      ofType(VehicleActions.getVehicleStats),
      switchMap(({ vehicleId }) => {
        return this.vehicleStatisticsApiService.getVehicleStats(vehicleId).pipe(
          map((vehicleStats) => {
            return VehicleActions.getVehicleStatsSuccess({ vehicleStats });
          }),
        );
      }),
    ),
  );

  addSpecToVehicle$ = createEffect(() =>
    this.actions$.pipe(
      ofType(VehicleActions.addSpecToVehicle),
      switchMap(({ specsSchema, vehicle, specName }) => {
        return this.vehicleApi
          .addSpecToVehicle(specsSchema, vehicle, specName)
          .pipe(
            map((vehicleResp: Vehicle) => {
              this.dialog.closeAll();
              return VehicleActions.addSpecToVehicleSuccess({
                vehicle: vehicleResp,
              });
            }),
            catchError((err) => of(VehicleActions.addSpecToVehicleError(err))),
          );
      }),
    ),
  );

  deleteSpecFromVehicle$ = createEffect(() =>
    this.actions$.pipe(
      ofType(VehicleActions.deleteSpecFromVehicle),
      switchMap(({ vehicle, specName }) => {
        return this.vehicleApi.deleteSpecFromVehicle(vehicle, specName).pipe(
          map((vehicleResp: Vehicle) => {
            this.dialog.closeAll();
            return VehicleActions.addSpecToVehicleSuccess({
              vehicle: vehicleResp,
            });
          }),
          catchError((err) => of(VehicleActions.addSpecToVehicleError(err))),
        );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private vehicleApi: VehicleApiService,
    private vehicleTypeApi: VehicleTypeApiService,
    private dialog: MatDialog,
    private vehicleStatisticsApiService: VehicleStatisticsApiService,
    private store: Store<fromVehicles.State>,
    private vehicleService: VehicleService,
  ) {}
}
